import { isModuleRegistered } from "SharedStores/util";
import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
import { RESULT_STATUS } from "../../evaluators/result";
import { EXPRESSION_TYPES } from "../../expressionTypes";
import { THOUSAND_SEPARATOR_FORMATTER } from "Util/dataFormatters";

export default {
    methods: {
        getReferenceDisplay(valueOverride) {
            switch (this.expression.Type) {
                case EXPRESSION_TYPES.FormulaReference:
                    return this._getFormulaReferenceDisplay();
                case EXPRESSION_TYPES.ProjectNumberReference:
                    return this._getProjectNumberReferenceDisplay(valueOverride);
                default:
                    return this._getDataFieldReferenceDisplay(valueOverride);
            }
        },
        _getDataFieldReferenceDisplay(valueOverride) {
            let unconfiguredDisplayText;
            switch (this.expression.Type) {
                case EXPRESSION_TYPES.BooleanDataFieldReference:
                    unconfiguredDisplayText = "Boolean Data Field Reference";
                    break;
                case EXPRESSION_TYPES.StringDataFieldReference:
                    unconfiguredDisplayText = "Text Data Field Reference";
                    break;
                case EXPRESSION_TYPES.DateDataFieldReference:
                    unconfiguredDisplayText = "Date Data Field Reference";
                    break;
                case EXPRESSION_TYPES.ChoiceEqual:
                case EXPRESSION_TYPES.ChoiceNotEqual:
                    unconfiguredDisplayText = "Choice Data Field Reference";
                    break;
                case EXPRESSION_TYPES.ExistsSameMultiInstanceValue:
                case EXPRESSION_TYPES.CoalesceMultiInstanceValue:
                case EXPRESSION_TYPES.SumMultiInstanceValue:
                case EXPRESSION_TYPES.CountTrueMultiInstanceValue:
                case EXPRESSION_TYPES.CountMatchingTextMultiInstanceValue:
                    unconfiguredDisplayText = "Multi-Instance Reference";
                    break;
                default:
                    unconfiguredDisplayText = "Data Field Reference";
            }

            if (this.expression.PublicDataFieldDefinitionId == null) {
                return unconfiguredDisplayText;
            }
            if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                throw Error("program store not registered");
            }

            const dataField = this.$store.getters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](
                this.expression.PublicDataFieldDefinitionId
            );
            const fieldName = dataField.Name;
            const showSeparators = dataField.ShowSeparators;

            const namePart = `{${fieldName}}`;
            if (this.expression.evalResult) {
                if (this.expression.evalResult.Status === RESULT_STATUS.Error) {
                    return namePart;
                }
                const value = valueOverride || this.expression.evalResult.Value;
                let valuePart = `${value}`;
                if (showSeparators) {
                    valuePart = THOUSAND_SEPARATOR_FORMATTER.format(valuePart);
                }
                if (this.expression.usingDefault) {
                    valuePart = `[${valuePart}]`;
                }
                return `${namePart}:${valuePart}`;
            }
            return namePart;
        },
        _getFormulaReferenceDisplay() {
            if (this.expression.ReferencedFormulaId == null) {
                return "Formula Reference";
            }
            if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                throw Error("program store not registered");
            }

            const formula = this.$store.getters[PROGRAM_TYPES.getters.formulaFromId](
                this.expression.ReferencedFormulaId
            );

            return `{Formula: ${formula.DisplayName}}`;
        },
        _getProjectNumberReferenceDisplay(valueOverride) {
            const namePart = "Project Number";
            if (this.expression.evalResult) {
                if (this.expression.evalResult.Status === RESULT_STATUS.Error) {
                    return namePart;
                }
                const value = valueOverride || this.expression.evalResult.Value;
                const valuePart = `${value}`;
                return `${namePart}:${valuePart}`;
            }
            return `${namePart}`;
        }
    }
};
